import { render, staticRenderFns } from "./Vacina.vue?vue&type=template&id=c23e309e&"
import script from "./Vacina.vue?vue&type=script&lang=js&"
export * from "./Vacina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports